import { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import styles from "page.module.css";

const SideTabBar = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabSelect = (index) => {
    setActiveTab(index);
  };
  return (
    <div className="container-fluid my-5">
      <div className="row">
        {/* Sidebar for tabs */}
        <div className="col-md-3">
          <Nav
            // variant="tabs"
            className={`flex-column ${styles.nav_tabs_custom}`}
            activeKey={activeTab.toString()}
          >
            {tabs.map((tab, index) => (
              <Nav.Item key={index}>
                <div className="m-2">
                  <div
                    className="d-flex"
                  >
                    <div
                      className={`col-10 text-center p-2 ${
                        activeTab === index
                          ? `${styles.bg_custom_3}`
                          : `${styles.bg_custom_6}`
                      }`}
                      onClick={() => handleTabSelect(index)}
                      style={{ cursor: 'pointer' }}
                    >
                      <span style={{ textTransform: "none" }}>{tab.label}</span>
                    </div>
                    <div
                      className={`col-2 my-3 ${
                        activeTab === index ? `${styles.triangle_right}` : `p-2`
                      }`}
                    ></div>
                  </div>
                </div>
              </Nav.Item>
            ))}
          </Nav>
        </div>
        {/* Content area */}
        <div className="col-md-9">
          <Tab.Content>
            {tabs.map((tab, index) => (
              <Tab.Pane
                key={index}
                eventKey={index.toString()}
                active={activeTab === index}
              >
                <div>{tab.element}</div>
              </Tab.Pane>
            ))}
          </Tab.Content>
        </div>
      </div>
    </div>
  );
};

export default SideTabBar;
